import React, { useEffect, useState } from 'react';
import Header from '@components/Comman/Header';
import { Button, Modal, Row, Col, Input, Select, Empty, Spin } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { formatAndCapitalizeString } from '@utils/comman';
// import { businessCategories, updatedBusinessServiceList } from '@utils/contstant';
import CardPagination from '@components/Comman/CardPagination';
import BusinessListing from '../ReferUsNetwork/FeatureCard';
import { getBusinessIReferAction } from '../../actions/refer';
import PageTitle from '@components/Comman/PageTitle';
import { getAllBusinessCategories } from '../../actions/business';
import { useNavigate } from 'react-router-dom';

interface DataType {
    key: string;
    firstName: string;
    lastName: string;
    email: string;
    businessCode: string;
    isRegistered: boolean;
}

const columns: ColumnsType<DataType> = [
    {
        title: 'Referred Date',
        dataIndex: 'createdAt',
        key: 'createdAt',
        sorter: (a: any, b: any) => a.createdAt?.localeCompare(b?.createdAt),
        render: (text) => {
            return <>{moment(text).format('DD/MM/YYYY')}</>
        }
    },
   
    {
        title: 'Contact Number',
        dataIndex: 'business',
        key: 'business',
        sorter: (a: any, b: any) => a.business?.BusinessDetails?.contactNumber?.localeCompare(b.business?.BusinessDetails?.contactNumber),
        render: (text) => {
            return <>{text?.BusinessDetails?.contactNumber}</>
        },
    },
    {
        title: 'Email',
        dataIndex: 'business',
        key: 'business',
        sorter: (a: any, b: any) => a.business?.email?.localeCompare(b.business?.email),
        render: (text) => {
            console.log(text)
            return <>{text?.email}</>
        },
    },
    {
        title: 'Business Name',
        dataIndex: 'business',
        key: 'business',
        sorter: (a: any, b: any) => a.business?.BusinessDetails?.businessName?.localeCompare(b.business?.BusinessDetails?.businessName),
        render: (text) => {
            return <>{text?.BusinessDetails?.businessName}</>
        },
    },
    {
        title: 'Category',
        dataIndex: 'businessCategory',
        key: 'businessCategory',
        sorter: (a: any, b: any) => a.businessCategory.localeCompare(b.businessCategory),
        render: (text) => <>{text && formatAndCapitalizeString(text)}</>,
    },
    {
        title: 'Contacted date',
        dataIndex: 'contactedDate',
        key: 'contactedDate',
        render: (text) => <>{text}</>,
    },
    {
        title: 'Paid Offer',
        dataIndex: 'paidOffer',
        key: 'paidOffer',
        render: (text) => <>{text}</>,
    },
    {
        title: 'Outcome',
        dataIndex: 'outcome',
        key: 'outcome',
        sorter: (a: any, b: any) => a?.outcome?.localeCompare(b?.outcome),
        render: (text) => <>{text}</>,
    },
   
];

const ComapanyIRefer = () => {
    const navigate = useNavigate();
    const [data, setData] = useState<DataType[]>([]);
    const [pagination, setPagination] = useState({ totalItems: 0 });
    const [pageSize, setPageSize] = useState(10);
    const [showConfirm, setShowConfirm] = useState(false)
    const [searchValues, setSearchValues] = useState({ businessName: '', category: '', postcode: '', otherCategory : '' });
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();
    const { isLoading } = useSelector((state: any) => state?.General);
    const { businessCategory } = useSelector((state: any) => state?.Business)
    useEffect(() => {
        dispatch(getAllBusinessCategories({}, () => { }))
    }, [])

    const getBusinessIReferData = (payloadD: any) => {
        const payload = { limit: pageSize, page: page, ...payloadD };
        dispatch(
            getBusinessIReferAction(payload, (resp: any) => {
                if (resp?.status === 200) {
                    setData(resp?.data);
                    setPagination(resp?.pagination);
                }
            })
        );


    }

    useEffect(() => {
        let payload = { limit: pageSize, page };
        getBusinessIReferData(payload);
    }, [page, pageSize, dispatch]);

    const handleTableChange = (pagination: any) => {
        setPage(pagination);
    };

    const handleSearch = (data: any) => {
        let values = {...searchValues};
        if(values.category == 'other'){
           values.category = values.otherCategory;
        }
        // ********* Required later on ************
        // if(isValidEmail(payload?.search)) {
        //     delete payload.search
        //  } else {
        //      delete payload.email
        //  }
        delete values.otherCategory;
        getBusinessIReferData(values);
    }

    const handleReset = () => {
        setSearchValues({
            businessName: '', category: '', postcode: '', otherCategory : ''
        });
        getBusinessIReferData({});
    };

    const tableComponent = (
        <>
            <div className="responsivetable">
                <div className='item-wrapper'>
                    {data?.map((item:any, index:number) => {
                        return (
                            <BusinessListing isBusiness={true} data={item?.business} key={index} />
                        )
                    })}
                </div>
                {data?.length === 0 && <div style={{ textAlign: 'center'}}><Empty /></div>}
            </div>
        </>
    );

    const userData = useSelector((state: any) => state?.Auth?.user);
const userRoleId = userData?.data?.roleId;

    return (
        <div>
            <div>
                <Header pagTitle={userRoleId === 2 ? "My Network" : "Business I Refer"}/>
                <div className="contentBody">
                    <div className="bodycard">
                        {
                            userRoleId === 2 && 
                            <>
                            <div className='d-flex ' style={{ justifyContent: 'space-between', paddingRight: '15px'}}>
                                <div >
                                    <b>Build your own referral network with businesses you already know.</b><br />
                                    <div className='d-flex' style={{ flexDirection: 'column', marginTop:'5px'}} >

                                    <span>
                                        Invite them in seconds, and once they're on ReferUs you can swap referrals directly  - quick, simple,
                                    </span><span> effective. Just hit "Invite a Business."</span>
                                    </div>
                                </div>

                                <div>
                        <button
                        className="btn link-button"
                        onClick={() => navigate('/invite-a-business')}
                        style={{ fontSize: '16px', fontWeight: 'bold' }}
                        >Invite a Business</button>
                        </div>
                        </div>
                        </>
                        }
                        {/* <Button size='small' style={{height: '39px', fontSize: '12px'}} className='btn btn-primary'>Invite a Business</Button> */}
                        <PageTitle pagTitle='' />
                        <div className=''>
                            <Row gutter={[16, 16]} style={{ marginBottom: '16px', width: '100%' }}>
                                {/* Business Name Input */}
                                <Col span={6} sm={24} lg={6} xs={24}>
                                    <Input
                                        placeholder="Enter business name"
                                        value={searchValues.businessName}
                                        style={{ height: '50px', marginBottom: '16px' }}
                                        onChange={(e) => setSearchValues({ ...searchValues, businessName: e?.target?.value })}
                                    />
                                </Col>

                                {/* Business Category Select */}
                                <Col span={6} sm={24} lg={6} xs={24}>
                                    <Select
                                        value={searchValues?.category || undefined} // Ensure this is undefined when no selection
                                        allowClear // Enable clear option
                                        style={{ width: '100%', height: '50px', marginBottom: '16px' }}
                                        onChange={(e) => setSearchValues({ ...searchValues, category: e })}
                                        placeholder="Business Category"
                                        showSearch
                                        filterOption={(input: any, option: any) => {
                                                return option?.children?.toLowerCase().includes(input.toLowerCase())
                                            }
                                        }
                                    >
                                        {businessCategory?.map((item: any, index: number) => {
                                            return <Select.Option key={index} value={item?.value}>{item?.label}</Select.Option>
                                        })}
                                    </Select>
                                    {/* <Select
                                        showSearch
                                        value={searchValues?.category || undefined} // Ensure this is undefined when no selection
                                        allowClear // Enable clear option
                                        placeholder="Search and select a business category"
                                        style={{ width: '100%', height: '50px', marginBottom: '16px' }}
                                        onChange={(e) => setSearchValues({ ...searchValues, category: e })}
                                        filterOption={(input: any, option: any) => {
                                            return option?.label?.toLowerCase().includes(input.toLowerCase())
                                        }
                                        }
                                        options={updatedBusinessServiceList}
                                    /> */}
                                </Col>
                                {/* Conditionally render the Other Category input */}
                                {searchValues.category === 'other' && (
                                    <Col span={6} sm={24} lg={6} xs={24}>
                                        <Input
                                            placeholder="Enter other business category"
                                            value={searchValues.otherCategory}
                                            style={{ height: '50px', marginBottom: '16px' }}
                                            onChange={(e) => setSearchValues({ ...searchValues, otherCategory: e.target.value })}
                                        />
                                    </Col>
                                )}

                                {/* Postcode Input */}
                                <Col span={6} sm={24} lg={6} xs={24}>
                                    <Input
                                        placeholder="PostCode"
                                        value={searchValues.postcode}
                                        style={{ height: '50px', marginBottom: '16px' }}
                                        onChange={(e) => setSearchValues({ ...searchValues, postcode: e?.target?.value })}
                                    />
                                </Col>

                                {/* Search Button */}
                                <Col span={3} sm={12} xs={12} lg={3}>
                                    <Button
                                        type="primary"
                                        className='btn btn-primary btn-filter'
                                        onClick={handleSearch}
                                    >
                                        Search
                                    </Button>
                                </Col>
                                <Col span={3} sm={12} xs={12} lg={3}>
                                    <Button
                                        // size='large'
                                        onClick={handleReset}
                                        className='btn-filter reset'
                                    >
                                        Reset
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                        <div className="cardContentbody">
                            {isLoading ? <Spin style={{padding: '25px', textAlign: 'center', display: 'block'}}></Spin> :tableComponent}
                        </div>
                        <div>
                            <CardPagination activePage={page} total={pagination?.totalItems || 0} handleChange={handleTableChange} />
                        </div>
                    </div>
                </div>
                <Modal
                    open={showConfirm}
                    title="Are you sure you want to become referrer?"
                    onOk={() => setShowConfirm(!showConfirm)}
                    onCancel={() => setShowConfirm(!showConfirm)}
                    footer={[
                        <Button key="back" className='btn btn-outline-primary-md' onClick={() => setShowConfirm(!showConfirm)}>
                            Cancel
                        </Button>,
                        <Button key="submit" className='btn btn-primary-md' type="primary" loading={isLoading} onClick={() => setShowConfirm(!showConfirm)}>
                            Ok
                        </Button>
                    ]}
                >
                    Once you click Ok it won't be reverted.
                </Modal>
            </div>
        </div>
    );
};

export default ComapanyIRefer;

